var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCheck = function SvgCheck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.06 7.024 9.54 18.038l-6.6-6.308 1.037-1.084 5.563 5.317L20.024 5.94l1.037 1.084Z"
  })));
};
export { SvgCheck as ReactComponent };
export default __webpack_public_path__ + "aa1d7c28cb9d48c0e3ffcea95bef3bcb.svg";